module.exports = __webpack_public_path__ + "h5/img/global_jnd.93aedbc1.png";